<template>
  <div>
    <Loading v-if="loading"></Loading>
    <van-form @submit="handleSubmit">
      <van-field
        v-model="formData.code"
        name="code"
        required
        label="品牌编号"
        placeholder="请输入品牌编号"
        :disabled="isView"
        :rules="[{ required: true, message: '请输入品牌编号' }]"
      />
      <van-field
        v-model="formData.name"
        name="name"
        required
        label="品牌名称"
        placeholder="请输入品牌名称"
        :disabled="isView"
        :rules="[{ required: true, message: '请输入品牌名称' }]"
      />
      <van-field
        v-model="formData.shortName"
        name="shortName"
        label="品牌简称"
        placeholder="请输入品牌简称"
        :disabled="isView"
      />
      <van-field name="logo" label="Logo" :disabled="isView">
        <template #input>
          <upload-image
            v-model="formData.logo"
            :disabled="isView"
            width="100px"
            height="100px"
          />
        </template>
      </van-field>
      <van-field
        v-model="formData.introduction"
        name="introduction"
        label="简介"
        placeholder="请输入简介"
        type="textarea"
        rows="4"
        :disabled="isView"
      />
      <van-field
        v-model="formData.description"
        name="description"
        label="备注"
        placeholder="请输入备注"
        type="textarea"
        rows="3"
        :disabled="isView"
      />

      <van-field
        v-if="showEnabled"
        name="available"
        label="状态"
        :disabled="isView"
      >
        <template #input>
          <van-switch
            v-model="formData.available"
            :disabled="isView"
            size="24px"
          />
        </template>
      </van-field>
      <div class="form-actions" v-if="!isView">
        <van-button
          block
          type="primary"
          native-type="submit"
          :disabled="loading"
        >
          保存
        </van-button>
      </div>
      <div class="form-actions">
        <van-button block @click="handleClose"> 关闭 </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { get, create, update } from "@/service/api/basedata/product/brand";
import Loading from "@/components/loading.vue";
import UploadImage from "@/components/uploadImage.vue";

export default {
  name: "ProductBrandDetail",
  components: {
    Loading,
    UploadImage,
  },
  data() {
    return {
      id: null,
      isView: true,
      loading: false,
      formData: {
        code: "",
        name: "",
        shortName: "",
        logo: "",
        introduction: "",
        description: "",
        available: true,
      },
     
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.isView = this.$route.params.type === "view";
    if (this.id) {
      this.loadDetail();
    }
  },
  computed: {
    showEnabled() {
      return !this.isNew;
    },
    isNew() {
      return !this.id;
    },
  },
  methods: {
    loadDetail() {
      this.loading = true;
      get({ id: this.id })
        .then((res) => {
          if (res.code === 200) {
            this.formData = {
              ...res.data,
            };
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    handleSubmit() {
      this.loading = true;
      const data = { ...this.formData };
      if (this.id) {
        data.id = this.id;
        update(data)
          .then((res) => {
            if (res.code === 200) {
              this.$toast.success("修改成功");
              this.$router.back();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        create(data)
          .then((res) => {
            if (res.code === 200) {
              this.$toast.success("新增成功");
              this.$router.back();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    handleClose() {
      this.$router.back();
    },

  },
};
</script>

<style lang="less" scoped>
.van-cell {
  padding: 5px 2px 2px 15px !important;
}
.form-actions {
  margin: 15px 10px;
}
</style>
